import util from "../../../share/src/util/utils";

/**
 * 登録情報を表示するか判定
 * ※国内VINでも登録番号の情報が全てnullであれば非表示（ファイル出力の場合は空文字列を出力）。
 * @param {Object} vin 対象車両のvin情報
 * @returns 登録情報を表示するかの判定結果（true：表示、false：非表示）
 */
export const outputRegistrationNumber = (vin) => {
  // 登録番号に関する情報が全てnullなら非表示
  const isOutput = (
    util.isNullOrDefault(vin.area_name) !== null ||
    util.isNullOrDefault(vin.category) !== null ||
    util.isNullOrDefault(vin.hiragana) !== null ||
    util.isNullOrDefault(vin.individual_number) !== null
  );
  return isOutput;
};

/**
 * 登録番号に表示する内容を作成
 * ※国内VINでも登録番号の情報が全てnullであれば非表示（ファイル出力の場合は空文字列を出力）。
 * @param {Object} vin 対象車両のvin情報
 * @param {String} spec 型式・区分またはMY
 * @returns 作成した登録番号
 */
export const createRegistrationNumber = (vin) => {
  const registrationNumber = ('{0} {1} {2} {3}').format(
    util.isNullOrDefault(vin.area_name, ''),
    util.isNullOrDefault(vin.category, ''),
    util.isNullOrDefault(vin.hiragana, ''),
    util.isNullOrDefault(vin.individual_number, '')
  );
  return registrationNumber;
};

export default {
  outputRegistrationNumber,
  createRegistrationNumber,
};